import { render, staticRenderFns } from "./indicatorChart.vue?vue&type=template&id=649b4616&scoped=true"
import script from "./indicatorChart.vue?vue&type=script&lang=js"
export * from "./indicatorChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b4616",
  null
  
)

export default component.exports